<template>
  <div class="cmp cmp-tab2-ktxc">
    <div class="tabs">
      <!-- 切换 班级 -->
      <template v-if="(userInfo.type === 'TEACHER' || userInfo.type === 'SCHOOL_MANAGER') && classList.length">
        <p
          :class="{ bg: item.id === currentClassId }"
          v-for="(item, index) in classList"
          :key="index"
          @click="switchClassChange(item)"
        >
          {{ item.gradeName + "-" + item.name }}
        </p>
      </template>

      <img class="refresh" @click="refreshChange" src="@/assets/images/onlinecourses/refresh.png" alt="" />
    </div>

    <div class="question_tips">
      <p class="question_total">共{{ classroomTestList.length }}题</p>
      <div class="student_switch_btn" v-if="userInfo.type === 'STUDENT'">
        <el-button @click="lastQuestionChange" size="small" type="primary" :disabled="currentQuestionIndex === 0"
          >上一题</el-button
        >
        <p>
          <span>{{ currentQuestionIndex + 1 }}</span
          >/{{ classroomTestList.length }}
        </p>
        <el-button
          @click="nextQuestionChange"
          size="small"
          type="primary"
          :disabled="currentQuestionIndex >= classroomTestList.length - 1"
          >下一题</el-button
        >
      </div>
      <div class="submitQuestion" v-if="userInfo.type === 'STUDENT'">
        <el-button type="primary" :disabled="isSubmitFlag" size="small" @click="submitQuestionChange">
          <b>提交全部练习</b>
        </el-button>
      </div>
      <div v-if="userInfo.type === 'TEACHER' || userInfo.type === 'SCHOOL_MANAGER'">
        <span>当前提交：</span>

        <el-progress
          style="width:200px;"
          :text-inside="true"
          :stroke-width="20"
          :percentage="Number(currentQuestionData.finishRate || 0)"
        ></el-progress>
      </div>
    </div>
    <div class="body" v-if="classroomTestList.length">
      <section
        class="ktxc_left"
        :style="{ '--width': userInfo.type === 'TEACHER' || userInfo.type === 'SCHOOL_MANAGER' ? '800px' : '1140px' }"
      >
        <p>题目{{ currentQuestionIndex + 1 }}</p>
        <!-- <div v-for="(item, index) in classroomTestList" :key="index"> -->
        <component :data="currentQuestionData" :is="`ktxc-${currentQuestionData.questionType}`"></component>
        <!-- </div> -->

        <section
          class="analysis"
          v-if="
            currentQuestionData.analysisFlag &&
              ['MULTIPLE_CHOICE', 'SINGLE_CHOICE'].includes(currentQuestionData.questionType)
          "
        >
          <p>
            答案解析：
          </p>
          <span>{{ currentQuestionData.analysis }}</span>
        </section>
      </section>
      <section class="ktxc_right" v-if="userInfo.type === 'TEACHER' || userInfo.type === 'SCHOOL_MANAGER'">
        <section>
          <el-button @click="lastQuestionChange" size="small" type="primary" :disabled="currentQuestionIndex === 0"
            >上一题</el-button
          >
          <p>
            <span>{{ currentQuestionIndex + 1 }}</span
            >/{{ classroomTestList.length }}
          </p>
          <el-button
            @click="nextQuestionChange"
            size="small"
            type="primary"
            :disabled="currentQuestionIndex >= classroomTestList.length - 1"
            >下一题</el-button
          >
        </section>

        <div class="ktxc_right_header">
          <p v-if="currentQuestionData.questionType !== 'SUBJECTIVE'">
            <i class="el-icon-success"></i>
            <span>正答率：{{ currentQuestionData.correctRate }} %</span>
          </p>
          <template v-if="userInfo.type === 'TEACHER' && classList.length">
            <p v-if="['MULTIPLE_CHOICE', 'SINGLE_CHOICE'].includes(currentQuestionData.questionType)">
              <span>答案解析</span
              ><el-switch
                v-model="currentQuestionData.analysisFlag"
                :active-value="1"
                :inactive-value="0"
                @change="switchChange"
              >
              </el-switch>
            </p>
          </template>
        </div>
        <div class="ktxc_right_header">
          <p>
            <i class="el-icon-success"></i>
            <span>完成率：{{ currentQuestionData.finishRate }} %</span>
          </p>
        </div>
        <div class="incomplete_student">未完成的学生：{{ currentQuestionData.undoNames.join(",") }}</div>
        <!-- {{ classroomTestList }} -->
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import publicUrl from "@/assets/js/interface";
// import subjectRadio from "./subject-radio.vue";
// import subjectCheckbox from "./subject-checkbox.vue";
// import subjectBlank from "./subject-blank.vue";
import ktxcSINGLE_CHOICE from "./ktxc-question/ktxc-SINGLE_CHOICE.vue";
import ktxcMULTIPLE_CHOICE from "./ktxc-question/ktxc-MULTIPLE_CHOICE.vue";
import ktxcSUBJECTIVE from "./ktxc-question/ktxc-SUBJECTIVE.vue";
export default {
  name: "cmp-tab2-ktxc",
  components: {
    // subjectRadio,
    // subjectCheckbox,
    // subjectBlank,
    ktxcSINGLE_CHOICE,
    ktxcMULTIPLE_CHOICE,
    ktxcSUBJECTIVE,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isSubmitFlag: false,
      currentQuestionIndex: 0,
      classList: [],
      currentClassId: null,
      questionType: "",
      classroomTestList: [],
      loadingCount: 0,
    };
  },
  computed: {
    ...mapState(["userInfo", "userAvatarDict", "messageParams"]),
    ...mapGetters({
      classActive: "classmanagement/classActive",
    }),
    currentQuestionData() {
      return this.classroomTestList[this.currentQuestionIndex] || {};
    },
  },
  watch: {
    data: {
      handler() {
        this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 切换班级
    switchClassChange(item) {
      this.currentClassId = item.id;
      this.getClassroomTestList();
    },
    // 答案解析开关事件
    switchChange() {
      this.$ajaxJson
        .post(publicUrl.analysisFlag, {
          id: this.currentQuestionData.id,
        })
        .then(() => {
          this.getClassroomTestList();
        })
        .catch((err) => {
          this.$ajaxError(err);
        });
    },
    // 提交答案
    submitQuestionChange() {
      if (this.isSubmitFlag) return false;
      let submitAnswers = [];
      let answer = null;
      this.classroomTestList &&
        this.classroomTestList.forEach((v) => {
          if (v.questionType === "MULTIPLE_CHOICE") {
            answer = (v.userAnswer || []).join(",");
          } else if (v.questionType === "SINGLE_CHOICE") {
            answer = v.userAnswer;
          } else if (v.questionType === "SUBJECTIVE" && v.subType !== "TXT") {
            answer = JSON.stringify(v.userAnswer);
          } else if (v.questionType === "SUBJECTIVE" && v.subType === "TXT") {
            answer = v.questionStem.content;
          }
          // 改答案才会提交
          if (answer || typeof answer === "number") {
            submitAnswers.push({
              answer: answer,
              questionId: v.id,
            });
          }
        });
      // 题目没作答 假提交
      if (!submitAnswers.length) {
        this.$message.success("提交成功");
        return false;
      }
      this.$ajaxJson
        .post(publicUrl.submitStudentWork, {
          answers: submitAnswers,
          taskModelId: this.data.id,
        })
        .then(() => {
          this.$message.success("提交成功");
          this.getClassroomTestList();
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$ajaxError(err);
        });
    },
    ...mapMutations({
      setModelsOnoff: "onlinecourses/setModelsOnoff",
    }),
    // 刷新按钮操作
    refreshChange() {
      this.getClassroomTestList();
    },
    // 上一题
    lastQuestionChange() {
      this.currentQuestionIndex--;
    },
    // 下一题
    nextQuestionChange() {
      this.currentQuestionIndex++;
    },
    init() {
      if (isNaN(parseInt(this.data.id))) return;
      // 教师请求学生列表
      if (this.userInfo.type === "STUDENT") {
        this.getClassroomTestList();
      } else if (this.userInfo.type === "TEACHER" || this.userInfo.type === "SCHOOL_MANAGER") {
        this.getAddStudentClassList();
      }
      // this.getModelDetails();
    },
    getAddStudentClassList() {
      let _this = this;
      _this.classList = [];
      // 查询年级班级列表
      this.$ajax
        .get(publicUrl.bookBindClass, {
          params: {
            bookId: this.$route.query.id,
          },
        })
        .then((res) => {
          let data = this.$ajaxCheck(res);
          function deepFn(arr) {
            arr &&
              arr.forEach((item) => {
                if (item.classes) {
                  deepFn(item.classes);
                } else {
                  _this.classList.push(item);
                }
              });
          }

          deepFn(data);
          if (_this.classList.length) {
            this.currentClassId = _this.classList[0].id;
          }
          this.$nextTick(() => {
            this.getClassroomTestList();
          });
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    getModelDetails() {
      this.loadingCount++;
      this.$ajax
        .get(publicUrl.modelDetails, {
          params: {
            classId: this.currentClassId || "",
            modelId: this.data.id,
            type: this.data.type,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            let _data = res.data.data || {};
            this.questionType = this.questionType_value2name[_data.questionType || ""];
            // if (_data.modelStatus) {
            this.setModelsOnoff({
              action: "add",
              data: { [`${this.classActive.id}_${this.data.id}`]: _data.modelValveId },
            });
            // } else {
            //   this.setModelsOnoff({
            //     action: 'remove',
            //     data: {[`${this.classActive.id}_${this.data.id}`]: false}
            //   })
            // }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    getClassroomTestList() {
      this.$ajax
        .get(publicUrl.classroomTestList, {
          params: {
            classId: this.userInfo.type === "STUDENT" ? this.userInfo.classId : this.currentClassId,
            testId: this.data.modelChildId,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data || {};
            this.isSubmitFlag = data.flag;
            this.classroomTestList = data.questions || [];

            if (this.messageParams.messageType && this.userInfo.type === "STUDENT") {
              this.classroomTestList &&
                this.classroomTestList.forEach((v, i) => {
                  if (v.id === this.messageParams.itemId) {
                    this.currentQuestionIndex = i;
                  }
                });
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.cmp-tab2-ktxc {
  background-image: linear-gradient(#ecf5fb, #ffffff);
  margin-bottom: 20px;
  height: 100%;
  min-height: 800px;
  .tabs {
    padding: 16px 0;
    margin: 0 30px;
    position: relative;
    display: flex;
    p {
      margin-right: 20px;
    }
    .refresh {
      position: absolute;
      right: 0;
      top: 10px;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
    .bg {
      color: #19a4ff;
    }
    p {
      &:hover {
        cursor: pointer;
        color: #19a4ff;
      }
    }
  }
  .question_tips {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: 0 42px 0px 42px;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-weight: bold;
        color: #19a4ff;
        margin-right: 10px;
      }
    }
  }
  .student_switch_btn {
    position: absolute;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
    p {
      margin: 0 40px;
    }
  }
  .submitQuestion {
    position: absolute;
    right: 0;
    top: 15px;
    i {
      font-size: 20px;
      color: #ffc528;
      cursor: pointer;
      margin-right: 10px;
    }
    p {
      margin: 0 40px;
    }
  }
  .question_total {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 22px;
    position: relative;
    margin: 20px 0;

    &::before {
      position: absolute;
      content: "";
      width: 2px;
      height: 16px;
      background: #19a4ff;
      border-radius: 1px;
      left: -12px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .body {
    display: flex;
    width: 100%;
    min-height: 600px;
    margin: 0 30px;
    .ktxc_left {
      width: var(--width);
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #d0d6da;
      padding: 0 20px;
      .analysis {
        margin-bottom: 20px;
        p {
          font-size: 16px;
          font-weight: bold;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #19a4ff;
          line-height: 20px;
          padding: 10px 0;
        }
        span {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
        }
      }
      > p {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #19a4ff;
        line-height: 20px;
        padding: 14px 0;
      }
    }
    .ktxc_right {
      width: 310px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #d0d6da;
      margin-left: 30px;
      .incomplete_student {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        padding: 0 20px;
      }
      .ktxc_right_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 20px;
        font-size: 16px;
        p {
          i {
            margin-right: 5px;
            color: #4add42;
            font-size: 16px;
          }
          span {
            vertical-align: middle;
            margin-right: 10px;
          }
        }
      }
      > section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        border-bottom: 1px solid #d0d6da;
        p {
          span {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #00a7ff;
          }
        }
      }
    }
  }
}
</style>
